<template>
  <div class="pages" v-loading="listLoading">
    <div
        v-for="(item, index) in templateData.TemplateContent.Controls"
        :key="index"
    >
      <Digit v-if="item.Property.Control == 'Number'" :data-val="item"></Digit>
      <Contact
          v-if="item.Property.Control == 'Condition'"
          :data-val="item"
      ></Contact>
      <Dates v-if="item.Property.Control == 'Date'" :data-val="item"></Dates>
      <Version
          v-if="item.Property.Control == 'Text'"
          @child-event="getTextVal"
          :data-val="item"
      ></Version>
      <Money v-if="item.Property.Control == 'Money'" :data-val="item"></Money>
      <Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
      <File v-if="item.Property.Control == 'File'" :data-val="item"></File>
      <Table
          v-if="item.Property.Control == 'Table'"
          @child-event="tableOperation"
          :data-val="item"
      ></Table>

      <Selector
          v-if="item.Property.Control == 'Selector'"
          @child-event="getSelectorVal"
          :data-val="item"
      ></Selector>
      <Textarea
          v-if="item.Property.Control == 'Textarea'"
          :data-val="item"
      ></Textarea>
      <Choose
          v-if="item.Property.Control == 'Contact'"
          @child-event="clickChoose"
          :data-val="item"
      ></Choose>
    </div>

    <Button
        class="submit-process"
        v-on:click="submit"
        v-bind:disabled="isDisabled"
        v-bind:loading="formLoading"
        size="large"
        type="primary"
    >
      提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Dates from "../components/Date.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";
import { getDepartmentInfo } from "@/api/department";
import {
  findExtates,
  findBuilding,
  findVaildHouseSource,
} from "@/api/nuisanceDisk";
import { getRelation, getAgentInfo } from "@/api/employee";
var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
name: "AResourceDeletion",
  components: {
    Contact,
    Dates,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
    };
  },
  created() {
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(true);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              var depart = res.result.departmentList[0]; // 已选的部门列表
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    getEmployeeRelation: async function (empNo) {
      await getRelation(empNo).then((response) => {
        this.relationList = response.Body[0].Nodes;
      });
    },
    getTextVal() {},
    getSelectorVal(val, name) {},
    tableOperation: async function (val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      var title = that.logInfo.fullName;
      var jobLevel = that.logInfo.JobLevel;
      console.log(jobLevel);
      if (
          title.indexOf("营业部/住宅部") == -1 ||
          (jobLevel > 5 && that.isDisabled == false)
      ) {
        that.Message({
          message: "没有申请权限",
          type: "error",
          duration: 1000,
        });
        that.isDisabled = true;
      }
      await that.getEmployeeRelation(that.logInfo.EmpNo);
      getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        var that = this;
        controls.TemplateContent.Controls.forEach(async (item) => {
          if (item.Property.Title[0].Text == "流程编号") {
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text == "申请部门") {
            item.Value = this.logInfo.DeptName;
            item.Disable = true;
          }
          if (item.Property.Title[0].Text == "申请人") {
            item.Value = this.logInfo.EmpName;
            item.Disable = true;
          }
          if (item.Property.Title[0].Text == "逐级审批使用") {
            item.Values = await that.getRelationList(this.relationList, 7);
            if (item.Values == null || item.Values.length < 1) {
              item.Values.push(this.$store.state.defaultMember);
            } else {
              let datas = item.Values;
              //获取逐级审批最后一个的工号
              let endEmpNo = datas[datas.length - 1][0];
              await getAgentInfo(endEmpNo).then((res) => {
                console.log("debu===")
                console.log(res)
                if (res.Body.PositionName.indexOf("店董") > -1) {
                  item.Values.push(this.$store.state.defaultMember);
                }
              });
            }
            item.IsShow = false;
          }
        });
        this.templateData = this.assignControl(controls, this.logInfo);
        this.listLoading = false;
      });
    },
    submit() {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }
      if (isSubmit) {
        this.Message({
          message: "已提交",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      var SummaryList = [];
      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      var control1 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text == "申请人";
      })[0];
      var control3 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text == "申请部门";
      })[0];
      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text:
            "申请人信息：" +
            " " +
            control1.Value +
            "  " +
            this.logInfo.EmpNo +
            "  " +
            control3.Value,
        Lang: "zh_CN",
      });
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList;

      isSubmit = true;
      this.listLoading = true;
      //提交
      submitProcess(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          this.templateData
      )
          .then((response) => {
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 3 * 1000,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 3000);
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  }
}
</script>

